module.exports = __webpack_public_path__ + "static/media/article.c3ec8c1d.svg";